export default "__VITE_PUBLIC_ASSET__ca9529a8__"